import {h, Component} from 'preact';
import {connect} from 'preact-redux';
import style from './style.scss'
import SystemModel from '/chat/src/redux/model/system/model';


class PoweredByJibber extends Component {
    render() {
        return (
            <div className={style.PoweredByJibber} style={this.props.hasFeatureFooter && {marginBottom: '40px'}}>
                <a href='https://jibber.se' className="" target='_blank'>Powered By <span>Jibber</span></a>
            </div>
        );
    }
}

function mapStateToProps(state){
    const features = state.getIn(['features', 'features']);
    return {
        hasFeatureFooter: features.has('faq_type')
    };
}
export default connect(mapStateToProps)(PoweredByJibber)



// WEBPACK FOOTER //
// ./components/PoweredByJibber/index.js